






import Vue from 'vue';
import Muuri from 'muuri';

export default Vue.extend({
  name: 'DashboardGrid',
  props: {
    resizing: Boolean,
  },
  watch: {
    resizing(isResizing) {
      if (!isResizing) {
        this.resized();
      }
    },
  },
  data() {
    return {
      grid: {} as Muuri,
      dragEnabled: true,
    };
  },
  created() {
    // 画面サイズ変更時にhandleResizeを呼び出す
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    // イベントリスナーを削除する
    window.removeEventListener('resize', this.handleResize);
  },
  mounted() {
    this.grid = new Muuri('.grid', {
      dragEnabled: true,
      dragHandle: '.item :not(.resize-icon)',
      dragCssProps: {
        touchAction: 'pan-y',
      },
      dragStartPredicate: (item, e) => {
        if (!this.dragEnabled) {
          return false;
        } else {
          return Muuri.ItemDrag.defaultStartPredicate(item, e);
        }
      },
      dragPlaceholder: {
        enabled: true,
        createElement(item) {
          const placeholder = document.createElement('div');
          return placeholder;
        },
      },
    });
    this.grid.on('move', (movedItem) => {
      // 移動中のつかんだ状態もここを通る
      // console.log('move',movedItem);
      this.$emit('onMoved', movedItem);
    });
    // console.log(this.grid);

    // DOM描画後に実行
    // width, heightがGADGET_HW以上だったらmargin分も追加
    this.$nextTick(() => {
      const GADGET_HW = 336;
      const MARGIN = 5;
      Array.from(document.getElementsByClassName('item') as HTMLCollectionOf<HTMLElement>).forEach((elem) => {
        const w = Math.round(elem.clientWidth / GADGET_HW);
        const h = Math.round(elem.clientHeight / GADGET_HW);
        if (w >= 2) {
          elem.style.width = `${w * GADGET_HW + (w - 1) * 2 * MARGIN}px`;
          // レイアウト再描画
          this.resized();
        }
        if (h >= 2) {
          elem.style.height = `${h * GADGET_HW + (h - 1) * 2 * MARGIN}px`;
          // レイアウト再描画
          this.resized();
        }
      });
      // 画面サイズ決定後にドラッグアンドドロップ可否設定
      this.handleResize();
    });
  },
  methods: {
    resized() {
      // console.log('resized');
      this.grid.refreshItems();
      this.grid.layout();
    },
    handleResize() {
      // PC表示の場合のみガジェットのドラッグアンドドロップを可能にする
      this.dragEnabled = window.innerWidth >= 960;
    },
  },
});

